import React, { useState } from 'react';

// Same fields and Formspree form as the previous drive.day contact page
const FORMSPREE_URL = 'https://formspree.io/f/xeqykwgp';

const BUSINESS_SIZES = [
    ['ADI', 'ADI (approved instructor)'],
    ['PDI', 'PDI (trainee instructor)'],
    ['Small', 'Small (2–10)'],
    ['Medium', 'Medium (11–20)'],
    ['Large', 'Large (21+)'],
];

function Forms() {
    const [status, setStatus] = useState({ state: 'idle', message: '' });

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.target;
        setStatus({ state: 'sending', message: '' });
        try {
            const response = await fetch(FORMSPREE_URL, {
                method: 'POST',
                body: new FormData(form),
                headers: { Accept: 'application/json' },
            });
            if (response.ok) {
                form.reset();
                setStatus({
                    state: 'sent',
                    message: "Thanks for your message! We'll be in touch soon.",
                });
                return;
            }
            const data = await response.json().catch(() => ({}));
            setStatus({
                state: 'error',
                message: data.errors
                    ? data.errors.map((error) => error.message).join(', ')
                    : 'Oops! There was a problem sending your message.',
            });
        } catch (error) {
            setStatus({ state: 'error', message: 'Oops! There was a problem sending your message.' });
        }
    };

    return (
        <>
            <section className="contact-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="contact--info-area">
                                <h3>Get in touch</h3>
                                <p>
                                    Questions about Drive.Day, or need a hand? Send us a message and
                                    we&apos;ll get back to you.
                                </p>
                                <div className="single-info">
                                    <h5>Headquarters</h5>
                                    <p>
                                        <i className="fa-jelly-fill fa-regular fa-house"></i>
                                        DayBadger LTD, 82 King Street,
                                        <br /> Manchester, M2 4WQ
                                    </p>
                                </div>
                                <div className="single-info">
                                    <h5>Phone</h5>
                                    <p>
                                        <i className="fa-jelly-fill fa-regular fa-phone"></i>
                                        <a href="tel:+443309128862">0330 912 8862</a>
                                    </p>
                                </div>
                                <div className="single-info">
                                    <h5>Email</h5>
                                    <p>
                                        <i className="fa-jelly-fill fa-regular fa-envelope"></i>
                                        <a href="mailto:hello@drive.day">hello@drive.day</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="contact-form">
                                <h4>Let&apos;s Connect</h4>
                                <p>If you have any questions or issues, please reach out below.</p>
                                <form onSubmit={handleSubmit} className="row">
                                    <div className="col-md-6">
                                        <input type="text" name="name" placeholder="Full Name" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="email" name="email" placeholder="Email" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="text" name="company" placeholder="Company" required />
                                    </div>
                                    <div className="col-md-6">
                                        <input type="tel" name="phone" placeholder="Phone" />
                                    </div>
                                    <div className="col-md-12">
                                        <select name="businessSize" defaultValue="" required>
                                            <option value="" disabled>
                                                Select business size&hellip;
                                            </option>
                                            {BUSINESS_SIZES.map(([value, label]) => (
                                                <option key={value} value={value}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-12">
                                        <textarea name="message" placeholder="Message" required></textarea>
                                    </div>
                                    <div className="col-md-8">
                                        {status.message && (
                                            <p className={`dd-form-status ${status.state}`} role="status">
                                                {status.message}
                                            </p>
                                        )}
                                    </div>
                                    <div className="col-md-4 text-right">
                                        <input
                                            type="submit"
                                            value={status.state === 'sending' ? 'Sending…' : 'Send message'}
                                            disabled={status.state === 'sending'}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="bisylms-map">
                <iframe
                    title="map"
                    src="https://maps.google.com/maps?width=720&amp;height=600&amp;hl=en&amp;q=DayBadger%20LTD%2C%2082%20King%20Street%2C%20Manchester%20M2%204WQ&amp;ie=UTF8&amp;t=p&amp;z=16&amp;iwloc=B&amp;output=embed"
                ></iframe>
            </div>
        </>
    );
}

export default Forms;
